module.exports = __webpack_public_path__ + "img/pasture_buffel_high.6ecd9b14.webp";